import React from "react";
import { useRef } from "react";
import { useState, useEffect } from "react";
import { developAxios } from "../axios.config";

function Qotd() {
	const [show, setShow] = useState("answer");
	const [date, setDate] = useState(null);
	const [question, setQuestion] = useState(null);
	const [answer, setAnswer] = useState(undefined);
	const [correctOption, setCorrectOption] = useState("A");
	const [options, setOptions] = useState({
		A: "",
		B: "",
		C: "",
		D: "",
	});

	function submitHandle() {
		developAxios(localStorage.getItem("token"))
			.post("/dashboard/upload-qotd", {
				date,
				question,
				type: show,
				options,
				correctOption,
				correctAnswer: answer,
			})
			.then(({ data }) => {
				console.log(data);
			})
			.catch((err) => console.log(err.response.data));
	}

	function setValue(option, value) {
		setOptions((prev) => {
			let temp = prev;
			temp[option] = value;
			return { ...prev };
		});
	}
	return (
		<>
			<div id="qotd">
				<h1>QOTD</h1>
				<div className="form-group">
					<h3>Select Date</h3>
					<input
						type="date"
						onChange={(e) => setDate(e.target.value)}
						value={date}
					/>
				</div>
				<br />
				<div className="select-input">
					<label for="cars">Write Question</label>
					<textarea
						onChange={(e) => setQuestion(e.target.value)}
						value={question}
						cols="10"
						rows="1"
					></textarea>
				</div>
				<div className="select-input">
					<label for="cars">Select option</label>
					<select
						onChange={(e) => setShow(e.target.value)}
						value={show}
					>
						<option value="answer">Question</option>
						<option value="mcq">MCQ</option>
					</select>
				</div>
				{show === "mcq" ? (
					<>
						<div className="qotd-option">
							<h3>Option</h3>
							<div className="row">
								<div className="col-6">
									<label>A</label>
									<input
										type="text"
										value={options.A}
										onChange={(e) =>
											setValue("A", e.target.value)
										}
										className="w-25"
									/>
								</div>
								<div className="col-6">
									<label>B</label>
									<input
										type="text"
										value={options.B}
										onChange={(e) =>
											setValue("B", e.target.value)
										}
										className="w-25"
									/>
								</div>
							</div>
							<div className="row">
								<div className="col-6">
									<label>C</label>
									<input
										type="text"
										value={options.C}
										onChange={(e) =>
											setValue("C", e.target.value)
										}
										className="w-25"
									/>
								</div>
								<div className="col-6">
									<label>D</label>
									<input
										type="text"
										value={options.D}
										onChange={(e) =>
											setValue("D", e.target.value)
										}
										className="w-25"
									/>
								</div>
							</div>
							<div className="select-input">
								<label for="option">Correct option</label>
								<select
									onChange={(e) =>
										setCorrectOption(e.target.value)
									}
									value={correctOption}
								>
									<option value="A">A</option>
									<option value="B">B</option>
									<option value="C">C</option>
									<option value="D">D</option>
								</select>
							</div>
						</div>
					</>
				) : (
					<>
						<br />
						<div className="select-input">
							<label>Ans</label>
							<input
								type="text"
								onChange={(e) => setAnswer(e.target.value)}
								value={answer}
							/>
						</div>
					</>
				)}
				<br />

				<button className="Qotd-btn" onClick={submitHandle}>
					SUBMIT
				</button>
			</div>
		</>
	);
}

export default Qotd;
